import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";

import { AgGridColumn, AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "./styles.css";

export default forwardRef(function Tables(props, ref) {
  const gridRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getRowStyle = (params) => {
    if (params.node.rowIndex % 2 === 0) {
      return { background: "#F6F7FF" };
    }
  };

  const rowStyle = { background: "white" };

  useImperativeHandle(ref, () => ({
    onBtnExport() {
      const options = {};
      if (gridRef.current.api.getSelectedNodes().length)
        gridApi.exportDataAsCsv({ ...options, onlySelected: true });
      else gridApi.exportDataAsCsv(options);
    },
  }));

  return (
    <>
      <div
        className="ag-theme-material"
        style={{ height: 620, width: "100%" }}
        id="#grid-theme-wrapper"
      >
        <AgGridReact
          ref={gridRef}
          rowData={props.tableData}
          suppressExcelExport={true}
          rowSelection="multiple"
          tooltipShowDelay={100}
          tooltipMouseTrack={true}
          rowHeight={60}
          defaultColDef={{
            filter: "agTextColumnFilter",
            resizable: true,
            sortable: true,
            headerComponentParams: {
              template:
                '<div class="ag-cell-label-container" role="presentation">' +
                '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
                '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
                '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
                '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
                '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
                '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                "  </div>" +
                "</div>",
            },
          }}
          onGridReady={onGridReady}
          pagination={true}
          paginationPageSize={10}
          rowStyle={rowStyle}
          getRowStyle={getRowStyle}
          suppressDragLeaveHidesColumns={true}
        >
          {props.headerNames.length > 0 && (
            <>
              {props.headerNames.map(
                ({ headerName, field, columnWidth, flex }, index) => (
                  <AgGridColumn
                    key={field}
                    headerName={headerName}
                    field={field}
                    flex={flex}
                    width={field == "caseId" ? 120 : columnWidth}
                    checkboxSelection={index == 0}
                    headerCheckboxSelection={index == 0}
                  />
                )
              )}
            </>
          )}
        </AgGridReact>
      </div>
    </>
  );
});
